/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClosedCaptionOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 18.888V2H5.112l2 2H20v12.888zm1.707 3.405-1.414 1.414L20.586 22H2V3.414L.293 1.707 1.707.293 15 13.585zM4 20h14.586l-4-4H13v-1.586L8.586 10H8v4h3v2H6V8h.586L4 5.414z" />
        <path d="M18 14.888V14h-.888zm-3-3V10h3V8h-5v1.888z" />
      </g>
    </g>
  </Icon>
);
export { SvgClosedCaptionOff as ClosedCaptionOff };
